import { QueryParamsService } from '../services/QueryParamsService/QueryParamsService';
export function getQueryParam(wixAPI, param) {
    var queryParamsService = new QueryParamsService({ location: wixAPI.location });
    return queryParamsService.getQueryParam(param);
}
export function getCurrencyHeader(wixAPI) {
    var currencyCode = getQueryParam(wixAPI, 'currency');
    return currencyCode !== null && currencyCode !== void 0 ? currencyCode : '';
}
export function getMultiLangHeader(wixAPI, storeId) {
    if (!wixAPI.window.multilingual.isEnabled) {
        return '';
    }
    var currentShortLang = wixAPI.window.multilingual.currentLanguage;
    var currentLang = getCurrentlyUsedMultilingualLanguage(wixAPI);
    if (!currentLang) {
        return '';
    }
    return "".concat(currentShortLang, "|").concat(currentLang.locale, "|").concat(currentLang.isPrimaryLanguage.toString(), "|").concat(storeId);
}
export function getCurrentlyUsedMultilingualLanguage(wixAPI) {
    var currentShortLang = wixAPI.window.multilingual.currentLanguage;
    return wixAPI.window.multilingual.siteLanguages.find(function (lang) { return lang.languageCode === currentShortLang; });
}
//# sourceMappingURL=headers.js.map